import { useAuthStore, getIsAgencyMember } from '@/stores/auth.store';

/**
 * Agency people: Solid staff, and partner-agency staff, who run several
 * projects of their own. Clients mostly have one or two projects, so the
 * cross-project tools (favorites, My tasks) aren't useful to them; they work
 * inside their project, where its Tasks screen shows what's assigned to them.
 */
export function useIsAgencyPerson(): boolean {
  const user = useAuthStore((s) => s.user);
  return getIsAgencyMember(user) || !!user?.organizations?.some((org) => org.type === 'PARTNER');
}
